import axios from 'axios';

const deleteFeedback = id => axios.delete(`feedback/${id}`);

export { deleteFeedback };
